import { render, staticRenderFns } from "./CImportProductsAdditionalData.vue?vue&type=template&id=2ad4eef0"
import script from "./CImportProductsAdditionalData.vue?vue&type=script&lang=js"
export * from "./CImportProductsAdditionalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@babel+core@8.0.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack_3967ed8cd784b60b7f0fd1a71945913e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports